import styled from 'styled-components'

const Header = styled('div')`
  margin: auto;
  height: 64px;
  width: 100%;
  padding: 0 24px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`

export default Header
